import { useEffect, useRef } from "react";

/**
 * Register a one-shot window `mouseup` handler and tear it down automatically
 * (when it fires, or on unmount). Used by the cell-based draggers (month grid,
 * all-day row) which track motion via per-cell `onMouseEnter` and only need the
 * drop/commit edge — collapsing the add/remove-listener + cleanupRef boilerplate
 * that was repeated for every gesture.
 */
export function useWindowMouseUp() {
  const cleanupRef = useRef<(() => void) | null>(null);
  useEffect(() => () => cleanupRef.current?.(), []);

  return function onMouseUpOnce(commit: () => void): void {
    function up() { cleanup(); commit(); }
    function cleanup() {
      window.removeEventListener("mouseup", up);
      cleanupRef.current = null;
    }
    cleanupRef.current = cleanup;
    window.addEventListener("mouseup", up);
  };
}
